export default __webpack_public_path__ + "static/media/939.17ce453d.png";